import { render, staticRenderFns } from "./TableClean.vue?vue&type=template&id=59de2f82&"
import script from "./TableClean.vue?vue&type=script&lang=js&"
export * from "./TableClean.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports